<template>
  <v-navigation-drawer class="sidebar-menu" dark fixed :value="true" :mobile-break-point="768" :clipped="true" :style="{ backgroundColor: styles.general.theme_color_dark}">
    <v-list dark class="menu_list_data">
      <v-list-group v-if="item.children" :key="i" v-for="(item, i) in items" :value="isOpen(item.link)">
        <v-list-tile color="grey" slot="activator">
          <v-list-tile-action>
            <v-icon color="white" class="menu_list_item_data">{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="white--text menu_list_item_data">
              {{ item.text }}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile :key="i" v-for="(sub_item, i) in item.children" router :to="sub_item.query ? `${sub_item.link}/${sub_item.query.page}` : `${sub_item.link}`">
          <v-list-tile-action>
            <v-icon color="white" class="menu_list_item_data">{{ sub_item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="white--text menu_list_item_data">
              {{ sub_item.text }}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list-group>

      <v-list-tile v-else router :to="item.link">
        <v-list-tile-action>
          <v-icon color="white" class="menu_list_item_data">{{ item.icon }}</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title class="white--text menu_list_item_data">
            {{ item.text }}
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </v-navigation-drawer>
</template>

<style lang="scss" scoped>
.sidebar-menu {
  top: 55px;
}

.list__tile--active{
  background-color: rgba(0, 0, 0, 0.1) !important;
}

.list__tile--active:hover{
  background-color: rgba(0, 0, 0, 0.1) !important;
}

.menu_list_data {
  width: 100%;
}

.menu_list_data li {
  margin-bottom: 12px;
  padding-right: 20px;
}

.menu_list_item_data {
  font-size: 16px;
}

.list__group i, .list__tile i {
  color: #a2a2a2;
}

.list__tile__action {
  min-width: 30px;
}

.list__group__items {
  background-color: rgba(0, 0, 0, 0.4);
}

.list__group__header--active {
  background-color: rgba(0, 0, 0, 0.4);
}

.list {
  background: transparent !important;
}
</style>

<script>
import 'font-awesome/css/font-awesome.min.css'

export default {
  data: () => ({
    items: [
      {
        icon: '',
        text: 'Home',
        link: '/admin/settings/home'
      },
      {
        icon: '',
        text: 'Settings',
        link: '/admin/settings/pages',
        children: [
          {
            icon: '',
            text: 'General Settings',
            link: '/admin/settings/pages',
            query: {
              page: 'general-settings'
            }
          },
          {
            icon: '',
            text: 'Email Settings',
            link: '/admin/settings/pages',
            query: {
              page: 'email-settings'
            }
          },
          {
            icon: '',
            text: 'Directory',
            link: '/admin/settings/pages',
            query: {
              page: 'directory'
            }
          },
          {
            icon: '',
            text: 'Resources',
            link: '/admin/settings/pages',
            query: {
              page: 'resources'
            }
          },
          {
            icon: '',
            text: 'Opportunities',
            link: '/admin/settings/pages',
            query: {
              page: 'opportunities'
            }
          },
          {
            icon: '',
            text: 'History',
            link: '/admin/settings/pages',
            query: {
              page: 'history'
            }
          },
          {
            icon: '',
            text: 'DoD Contract Analytics',
            link: '/admin/settings/pages',
            query: {
              page: 'dod-contract-analytics'
            }
          },
          {
            icon: '',
            text: 'Bid Alerts',
            link: '/admin/settings/pages',
            query: {
              page: 'bid_alerts'
            }
          },
          {
            icon: '',
            text: 'Questionnaire',
            link: '/admin/settings/pages',
            query: {
              page: 'questionnaire'
            }
          },
          {
            icon: '',
            text: 'Favorites',
            link: '/admin/settings/pages',
            query: {
              page: 'favorites'
            }
          },
          {
            icon: '',
            text: 'Tracking',
            link: '/admin/settings/pages',
            query: {
              page: 'tracking'
            }
          }
        ]
      },
      {
        icon: '',
        text: 'Users',
        link: '/admin/settings/users',
        children: [
          {
            icon: '',
            text: 'Manage Users',
            link: '/admin/settings/users',
            query: {
              page: 'manage-users'
            }
          },
          {
            icon: '',
            text: 'Usage Tracking',
            link: '/admin/settings/users',
            query: {
              page: 'usage-tracking'
            }
          },
          {
            icon: '',
            text: 'Default Chat Contact',
            link: '/admin/settings/users',
            query: {
              page: 'default-chat-contact'
            }
          }
        ]
      },
      {
        icon: '',
        text: 'Access',
        link: '/admin/settings/priviledges'
      },
      {
        icon: '',
        text: 'Resources',
        link: '/admin/resources/all'
      },
      {
        icon: '',
        text: 'Companies',
        link: '/admin/companies',
        children: [
          {
            icon: '',
            text: 'Update Company',
            link: '/admin/companies/update-company'
          },
          {
            icon: '',
            text: 'Add Company',
            link: '/admin/companies/add-company'
          }
        ]
      },
      {
        icon: '',
        text: 'Requests',
        link: '/admin/settings/requests',
        children:
        [
          {
            icon: '',
            text: 'Activity Stream',
            link: '/admin/settings/requests',
            query: {
              page: 'activity'
            }
          },
          {
            icon: '',
            text: 'Events',
            link: '/admin/settings/requests',
            query: {
              page: 'events'
            }
          },
          {
            icon: '',
            text: 'Company Submission',
            link: '/admin/settings/requests',
            query: {
              page: 'companies'
            }
          }
          // {
          //   icon: '',
          //   text: 'Group Post',
          //   link: '/admin/settings/requests',
          //   query: {
          //     page: 'groups'
          //   }
          // },
          // {
          //   icon: '',
          //   text: 'Group Events',
          //   link: '/admin/settings/requests',
          //   query: {
          //     page: 'group-events'
          //   }
          // }
        ]
      },
      {
        icon: '',
        text: 'Feedback/Support',
        link: '/admin/settings/support',
        children: [
          {
            text: 'Feedback',
            link: '/admin/settings/support',
            query: {
              page: 'feedback'
            }
          },
          {
            text: 'Help Requests',
            link: '/admin/settings/support',
            query: {
              page: 'help-requests'
            }
          }
        ]
      },
      {
        icon: '',
        text: 'Admin Tutorials',
        link: '/admin/settings/tutorials',
        children: [
          {
            text: 'All Tutorials',
            link: '/admin/settings/tutorials',
            query: {
              page: 'all'
            }
          },
          {
            text: 'Manage Tutorials',
            link: '/admin/settings/tutorials',
            query: {
              page: 'manage'
            }
          }
        ]
      }
    ]
  }),
  computed: {
    styles () {
      return this.$store.getters.getStyles
    }
  },
  methods: {
    async checkUserRole () {
      var usr = this.$store.getters.getUserDetails

      var fb = this.$firebase.database().ref()

      let user = await fb.child('users/' + usr.uid.toString()).once('value')

      if (user.role !== 1) {
        let alert = {
          ative: true,
          header: 'Access denied',
          text: "You don't have access on this page",
          okText: 'Ok',
          cancelText: ''
        }
        this.$store.dispatch('triggerAlert', alert)
        this.$router.push('/user/feed')
      }
    },
    isOpen (rootPath) {
      return this.$route.fullPath.indexOf(rootPath) > -1
    }
  }
}
</script>



// WEBPACK FOOTER //
// AdminSideBar.vue?b23c3902